<template>
  <v-btn
    v-bind="options"
    v-on="$listeners"
  >
    <slot />
  </v-btn>
</template>

<script>
  export default {
    inheritAttrs: false,

    props: {
      cancel: Boolean,
      color: {
        type: String,
        default: 'secondary'
      },
      confirm: Boolean,
      fab: Boolean,
      emphasized: Boolean
    },

    computed: {
      options () {
        const option = [
          'cancel',
          'confirm',
          'fab',
          'emphasized'
        ].find(val => (this[val]))

        if (!option) return undefined

        const options = this[`${option}Options`]()

        if (!options.color) options.color = this.color

        return {
          ...options,
          ...this.$attrs
        }
      }
    },

    methods: {
      cancelOptions () {
        return {
          color: 'grey',
          flat: true
        }
      },
      confirmOptions () {
        return {
          //
        }
      },
      fabOptions () {
        return {
          depressed: true,
          fab: true
        }
      },
      emphasizedOptions () {
        return {
          large: true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/core/Btn.vue